<template>
  <div class="w-full px-6 py-5">
    <div class="w-full flex justify-between gap-8 items-center">
      <div class="w-full flex flex-col gap-4 divide-y divide-utility-gray-200">
        <div
          @click="open = !open"
          class="flex items-center gap-4 cursor-pointer max-md:justify-between"
        >
          <Icon
            v-if="!maxSmall"
            :name="open ? 'chevron-down' : 'chevron-right'"
          />
          <div class="flex flex-col">
            <div class="text-utility-gray-700 text-base font-semibold">
              {{ message.name }}
            </div>
            <div class="text-tertiary text-sm font-normal">
              {{ message.description }}
            </div>
          </div>
          <Icon
            v-if="maxSmall"
            :name="open ? 'chevron-down' : 'chevron-right'"
            class="min-w-min"
          />
        </div>
        <div class="pt-4 md:pl-8 flex flex-col gap-4" v-if="open && isLoaded">
          <Fields
            :tags="placeholders"
            :fields="fields"
            :values="values"
            :locale="locale"
            @onInput="handleInputChange"
            @update="update"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import route from "ziggy-js";
import { toast } from "@/SharedComponents/Toaster";
import { ref, onMounted, watch } from "vue";
import { Fields } from "@/Pages/Settings/MessengerFlow/Partials";
import { Icon } from "@/SharedComponents/Icon";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { useI18n } from "vue-i18n";

const open = ref(false);
const fields = ref([]);
const values = ref([]);
const placeholders = ref([]);
const isLoaded = ref(false);
const { maxSmall } = useBreakpoints();
const { t } = useI18n();

const props = defineProps({
  message: { type: Object, required: true },
  locale: { type: String, required: true },
  tenant: { type: Object, required: true },
});

const handleInputChange = ({ field, value }) => {
  values.value[field] = value;
};

const getData = () => {
  axios
    .get(
      route("settings.messenger.screen.edit", {
        screen: props.message.id,
        tenant: props.tenant.id,
        locale: props.locale,
      })
    )
    .then((result) => {
      fields.value = result.data.screen.fields;
      placeholders.value = fields.value.reduce(
        (acc, field) => [...acc, ...field.placeholders],
        []
      );
      values.value = result.data.values;
      isLoaded.value = true;
    });
};

watch(props, () => {
  open.value = false;
  getData();
});

onMounted(() => {
  getData();
});

const update = () => {
  axios
    .put(
      route("settings.messenger.screen.update", {
        screen: props.message.id,
        tenant: props.tenant.id,
        locale: props.locale,
        fields: values.value,
      })
    )
    .then((result) => {
      toast.success(t("toasts.default.update.success", 2));
      values.value = result.data.values;
    })
    .catch((err) => {
      if (err.response.status == 403) {
        toast.error(t("toasts.default.update.403", 2));
      } else {
        toast.error(
          err.response.data.message || t("toasts.default.update.error", 2)
        );
      }
    });
};
</script>
